// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// EXTERNAL DEPENDANCY
import { Observable } from 'rxjs';

// SERVICES
import { ApiConfigService } from '../../../core/services/api-config/api-config.service';
import { BaseService } from '../../../core/services/base/base.service';
import { TokenStorageService } from '../../../core/services/token-storage/token-storage.service';

// COMMON INTERFACES
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../../models/common/api/api-response.interface';

// COMMON UTILS
import { APIUtil } from '../../../../core/utils/api-util';

// CONSTANTS
import { REQUEST_API_URL } from '../../../../constants/api/request';

/**
 * This service is for request api calls
 * For handle request api calls
 *
 * @author Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>
 *
 * Date: 17/06/2020 (Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>) initially created request service
 */
@Injectable()
export class RequestService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }

  /**
       * request common master api
       * @param payload : Api common payload object
       * @returns Observable<ApiResponse>
       */
  public requestCommon(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['type'];
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${REQUEST_API_URL[payload.data.type]}`, replaceParams, payload);

    return this.post(url, payload.data.data);
  }

  /**
   * User request list
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getUserRequestList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.USER_REQUEST}`;

    return this.get(url);
  }

  /**
  * Select the business
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public approveRejectUserRequest(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.APPROVE_REJECT_USER_REQUEST}`;

    return this.post(url, payload);
  }

  /**
   * Leave request list
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getLeaveRequestList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.LEAVE_REQUEST}`;

    return this.post(url, payload);
  }


  /**
   * Leave request list
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getOpenRequestList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.OPEN_REQUEST_PAGING}`;

    return this.post(url, payload);
  }  /**
  * Leave request list
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getSwapRequestList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.SHIFT_SWAP_REQUEST_PAGING}`;

    return this.post(url, payload);
  }
    /**
   * Leave request list
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
     public getOpenRequestAllList(payload: ApiPayload): Observable<ApiResponse> {
      const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.OPEN_REQUEST_EXPORT}`;

      return this.post(url, payload);
    }
      /**
   * Leave request list
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getSwapRequestAllList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.SHIFT_SWAP_REQUEST_EXPORT}`;

    return this.post(url, payload);
  }

  /**
   * Leave request list
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getLeaveRequestAllList(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.LEAVE_REQUEST}`;

    return this.post(url, payload);
  }

  /**
     * Leave request list
     * @param payload : Api common payload object
     * @returns Observable<ApiResponse>
     */
  public getLeaveRequestAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.LEAVE_REQUEST_ALL}`;

    return this.post(url, payload);
  }
  /**
   * get Leave By Id
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getLeaveById(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['employee_leave_id'];
    // get url
    const url = APIUtil.getReplaceParams(
      `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.LEAVE_BY_ID}`,
      replaceParams,
      payload,
    );

    return this.get(url);
  }

  /**
   * Select the business
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public approveRejectLeaveRequest(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${REQUEST_API_URL.APPROVE_REJECT_LEAVE_REQUEST}`;

    return this.put(url, payload);
  }
}
